module.exports = __webpack_public_path__ + "static/media/create_reservation_select_fraction_time.97b0536d.jpg";